var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFullChevronRightBlack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 7,
    height: 11,
    viewBox: "0 0 7 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.21094 5.10156C6.42188 5.33594 6.42188 5.6875 6.21094 5.89844L1.71094 10.3984C1.47656 10.6328 1.125 10.6328 0.914062 10.3984C0.679688 10.1875 0.679688 9.83594 0.914062 9.625L5.01562 5.52344L0.914062 1.39844C0.679688 1.1875 0.679688 0.835938 0.914062 0.625C1.125 0.390625 1.47656 0.390625 1.6875 0.625L6.21094 5.10156Z",
    fill: "#15161F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFullChevronRightBlack);
export default __webpack_public_path__ + "static/media/icon-full-chevron-right-black.a333d0cec85247b25638ed23add74b19.svg";
export { ForwardRef as ReactComponent };